export { default } from './TextBanner'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/TextBanner/index.js